var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMedallion = function SvgMedallion(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0448 28.2915C13.6088 32.396 11.3608 34.306 8.28748 38.6107L15.5763 37.3782L19.1303 42.822C21.7209 38.8188 23.266 36.277 24.7008 32.6367",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6348 35.4557C25.2618 38.9964 25.9065 41.1468 28.0695 45.4754L31.1417 39.1598L37.4666 40.5897C35.4366 36.8198 33.4671 33.4733 32.1038 30.0618",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8554 3.69637C22.9896 2.39623 25.0223 2.4098 26.1564 3.70994C26.8871 4.54759 28.0424 4.89562 29.1115 4.59145L30.2045 4.2805C31.6962 3.85608 33.1798 4.97646 33.1798 6.52744C33.1798 7.64425 33.9703 8.60486 35.0662 8.81986L35.2758 8.86096C36.8199 9.16388 37.7415 10.7601 37.2318 12.2488L37.1145 12.5913C36.7616 13.622 37.0137 14.7635 37.7679 15.5498L38.1664 15.9653C39.3123 17.1598 39.2493 19.0637 38.027 20.1798L37.7769 20.4082C37.031 21.0893 36.7795 22.1582 37.1433 23.1005C37.6923 24.522 36.8245 26.0945 35.3292 26.3878L34.988 26.4547C33.8946 26.6692 33.0364 27.5407 32.8219 28.6342C32.4938 30.3064 30.7595 31.3334 29.1472 30.7814C28.0665 30.4114 26.8693 30.7321 26.1183 31.593C24.9981 32.8772 23.002 32.8772 21.8817 31.593C21.1308 30.7321 19.9336 30.4114 18.8528 30.7814L18.7239 30.8256C17.1798 31.3542 15.5243 30.3984 15.2101 28.7969L15.1867 28.6776C14.9696 27.5712 14.0468 26.7419 12.9236 26.6438C11.3184 26.5036 10.2513 24.9188 10.7251 23.3787L10.8897 22.8437C11.2316 21.7324 10.8244 20.5176 9.89102 19.8243C8.43029 18.7395 8.40807 16.5362 9.8688 15.4514C10.8167 14.7474 11.1953 13.4961 10.8128 12.379C10.2838 10.834 11.2321 9.15368 12.8347 8.8393L12.9523 8.81623C14.0589 8.59915 14.8889 7.67699 14.9887 6.55374C15.1314 4.94757 16.7181 3.8814 18.2591 4.35619L18.8729 4.54531C19.9475 4.8764 21.1163 4.54372 21.8554 3.69637Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2647 29.9812C31.9493 31.5891 29.9297 32.4789 28.3795 31.9481C27.4294 31.6228 26.6772 31.9393 26.0491 32.626C25.8038 32.8941 25.5461 33.1527 25.256 33.3716C24.9426 33.6081 24.7618 33.7779 24.2807 34.0987",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4512 17.9609C34.2665 23.7347 29.941 28.282 24.1672 28.0973C18.3934 27.9126 13.3577 23.0656 13.5424 17.2918C13.7272 11.518 18.5639 6.78807 24.3377 6.97282",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9529 25.8241L25.2898 19.0602C25.9591 19.3453 26.6957 19.5032 27.4691 19.5032C30.542 19.5032 33.0331 17.0121 33.0331 13.9392C33.0331 13.7692 33.032 13.6075 33.0265 13.4508C33.0071 12.8947 32.3707 12.7228 31.9772 13.1163L29.2476 15.8459C28.8577 16.2358 28.2254 16.2358 27.8355 15.8459L25.5325 13.5428C25.1425 13.1529 25.1425 12.5206 25.5325 12.1307L28.2336 9.42954C28.6295 9.03365 28.4527 8.39594 27.8931 8.38C27.7565 8.37611 27.6159 8.37524 27.4691 8.37524C24.3962 8.37524 21.9052 10.8663 21.9052 13.9392C21.9052 14.6986 22.0573 15.4225 22.3328 16.082L15.1215 22.6709",
    stroke: "black",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1459 26.0172L24.6759 20.0985C25.1098 19.7053 25.7293 19.6185 26.2995 19.7514C26.7067 19.8462 27.131 19.8964 27.567 19.8964C30.6399 19.8964 33.131 17.4053 33.131 14.3324C33.131 14.1624 33.1299 14.0007 33.1244 13.844C33.105 13.2879 32.6531 12.3145 31.9414 13.1597",
    stroke: "black",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3359 8.56726L28.7675 9.14278L26.0064 12.1508C25.5552 12.6424 25.5183 13.3858 25.9187 13.9196V13.9196",
    stroke: "black",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMedallion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "medallion.22d7f6f383aff32d25b743233c594ffd.svg";